import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { endsWith } from 'lodash';
import { CommonAppDataService } from '../services/app_data/app_data.service';

@Injectable()
export class CommonPrefixUrlInterceptor implements HttpInterceptor {
	private serverPrefix: string;
	private isDevServer: boolean;

	constructor (
		private commonAppDataService: CommonAppDataService,
	) {
		const { meetingsAuth: { prependedUrl = '' }, isDevServer } = this.commonAppDataService.getData();
		this.serverPrefix = prependedUrl;
		this.isDevServer = isDevServer;
	}

	intercept (req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		let fixedReq = req;

		if (this.isDevServer && this.serverPrefix && !endsWith(req.url, '.html') && !endsWith(req.url, '.json')) {
			fixedReq = req.clone({
				url: this.serverPrefix + req.url,
			});
		}

		return next.handle(fixedReq);
	}
}
